import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Cpu, Router, Tablet, Printer, Gauge, Radio } from "lucide-react";

const items = [
  { i: Router, name: "BEEDIGIT HUB", text: "Industrial connectivity hub for collecting machine and energy data and sending it securely to BEEDIGIT cloud.", use: ["Machine status", "Energy tracking", "Sensor polling", "GSM / LAN"] },
  { i: Cpu, name: "BEEDIGIT EDGE", text: "Machine connectivity layer for reading parameters directly from PLCs and industrial equipment where available.", use: ["PLC data", "Process parameters", "Output tracking", "Downtime tracking"] },
  { i: Tablet, name: "BEEPAD Industrial Tablet", text: "Rugged operator tablet for shop-floor execution.", use: ["Digital job orders", "QR scanning", "Quality checks", "Maintenance requests"] },
  { i: Printer, name: "BEEPRINT Industrial Printer", text: "Industrial label printer for QR coding and traceability.", use: ["RM/SFG/FG labels", "Drum labels", "Pallet labels", "Batch labels"] },
  { i: Gauge, name: "BEECT Energy Tracker", text: "Wireless current meters for energy consumption tracking.", use: ["Machine-level energy", "Energy per order", "ISO 50001 analysis", "Load profile"] },
  { i: Radio, name: "HoneyPlug Output Tracker", text: "Industrial signal tracking device for machine output and events.", use: ["Output counting", "Line speed signals", "Digital inputs", "Analog inputs"] },
];

export default function HardwareBlock() {
  const { t } = useLanguage();
  return (
    <section id="hardware" className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Hardware")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Industrial hardware, preconfigured and ready to use.")}</h2>
          <p className="text-muted-foreground">
            {t("BEEDIGIT is not only software. We deliver the industrial hardware needed to connect machines, operators, labels, energy and shop-floor events from day one.")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div key={it.name} className="rounded-lg border border-border bg-card p-5 flex flex-col">
              <it.i className="h-6 w-6 text-primary mb-3" />
              <h3 className="font-semibold mb-2">{t(it.name)}</h3>
              <p className="text-sm text-muted-foreground mb-3">{t(it.text)}</p>
              <div className="mt-auto flex flex-wrap gap-1.5">
                {it.use.map((u) => (
                  <span key={u} className="text-[11px] rounded-full border border-border bg-background/50 px-2 py-0.5 text-foreground/75">{t(u)}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-foreground max-w-3xl">
          {t("All BEEDIGIT hardware is selected and configured for industrial environments. Devices are delivered preconfigured for the customer's project scope to reduce installation time and simplify onboarding.")}
        </p>
        <div className="mt-6">
          <Button variant="outline" asChild>
            <Link to="/hardware">{t("See Hardware Kit")} <ArrowRight className="ms-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </section>
  );
}